import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0a4195a9&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=0a4195a9&lang=less&rel=stylesheet%2Fless&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4195a9",
  null
  
)

export default component.exports